import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Icon from './icons/IconFactory'

import './IconButton.scss'

class IconButton extends Component {

  constructor (props) {
    super(props)
    this.state = {
      hover: false,
    }
  }

  render () {
    const styleClass = 'icon-button' +
      (this.props.className ? ' ' + this.props.className : '') +
      (this.props.selected ? ' selected' : '') +
      (this.props.border ? '' : ' no-border') +
      (this.props.disabled ? ' disabled' : '')

    if (this.props.activeOnHover) {
      return (
        <button title={this.props.tooltip ? this.props.tooltip : undefined} disabled={this.props.disabled} style={this.props.style} className={styleClass} onClick={this.props.onClick}
                onMouseEnter={() => this.toggleHover()}
                onMouseLeave={() => this.toggleHover()}>
          <Icon disabled={this.props.disabled} inverted={this.props.inverted} name={this.props.icon} active={this.state.hover} highlight={this.props.highlight} forceColor={this.props.forceColor}/>
        </button>
      )
    } else {
      const onMouseEnter = this.props.onMouseEnter ? this.props.onMouseEnter : () => {}
      const onMouseLeave = this.props.onMouseLeave ? this.props.onMouseLeave : () => {}

      return (
        <button title={this.props.tooltip ? this.props.tooltip : undefined}
                disabled={this.props.disabled}
                style={this.props.style}
                className={styleClass}
                onClick={this.props.onClick}
                onDoubleClick={this.props.onDoubleClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}>
          <Icon disabled={this.props.disabled} inverted={this.props.inverted} name={this.props.icon} active={this.props.active} highlight={this.props.highlight}  forceColor={this.props.forceColor}/>
        </button>
      )
    }

  }

  toggleHover () {
    this.setState({ hover: !this.state.hover })
  }

}

IconButton.protoType = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
  active: PropTypes.bool,
  selected: PropTypes.bool,
  tooltip: PropTypes.string,
}

export default IconButton
